export const INCOME_COMMITMENT_TYPE = {
    recurring: 'forecast_recurring',
    oneTime: 'forecast_one_time',
    activity: 'forecast_activity',
    interest: 'forecast_interest',
    specialAssessment: 'special_assessment',
    runRate: 'run_rate',
};
const STORED_TYPES = new Set(Object.values(INCOME_COMMITMENT_TYPE));
export function isIncomeCommitmentType(type) {
    return type !== null && STORED_TYPES.has(type);
}
export const INCOME_FORECAST_ONLY_TYPES = [
    INCOME_COMMITMENT_TYPE.recurring,
    INCOME_COMMITMENT_TYPE.oneTime,
    INCOME_COMMITMENT_TYPE.activity,
    INCOME_COMMITMENT_TYPE.interest,
    INCOME_COMMITMENT_TYPE.runRate,
];
export const ADDABLE_INCOME_KINDS = ['recurring', 'one_time', 'activity', 'interest'];
export const INCOME_CLASSES = ['regular', 'incidental', 'pass_through'];
export const INCOME_FUNDS = ['operating', 'capital_project', 'facade', 'other'];
export const ONE_TIME_INCOME_STATUSES = ['expected', 'received', 'uncertain'];
export const INTEREST_HELD_IN = ['operating', 'reserves'];
export const CREDIT_LOSS_PERCENT_RANGE = { min: 0, max: 100 };
export const SPECIAL_ASSESSMENTS_CATEGORY = 'Special Assessments';
export const UNIT_BILLING_INCOME_CATEGORIES = {
    association: ['Common Charges', SPECIAL_ASSESSMENTS_CATEGORY],
    rental: ['Rental Income'],
};
export function isCoveredByUnitBilling(kind, category) {
    const covered = UNIT_BILLING_INCOME_CATEGORIES[kind];
    return covered.includes(category);
}
export const OCCUPANCY_PERCENT_RANGE = { min: 0, max: 100 };
//# sourceMappingURL=incomeCommitments.js.map